import React from "react";
import styles from './EditorButtons.module.scss';
import {IProduct} from 'data/interfaces/products';
import {MDBBtn} from 'mdbreact';
import LinkBlockContainer from 'data/redux/containers/linkBlockContainer';
import {generateSluggedAdUrl, generateSluggedEditUrl} from 'data/redux/actions/guiActions';
import {Route, Switch} from 'react-router';
import {linksMap} from 'data/utils/constants';
import {When} from 'react-if';
import {Button} from '@material-ui/core';
import {
  PRODUCT_STATUS_DISAPPROVED,
  PRODUCT_STATUS_PUBLISHED,
  PRODUCT_STATUS_WAITING_FOR_APPROVAL
} from 'data/redux/constants/productsConstants';
import {eCheckType, getLastPossibleNavigation} from 'data/utils/shortcuts';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';

export interface IEditorButtons {
  product: IProduct;
  isProductOwner: boolean;
  isOrderOwner: boolean;
  nextEditorRef?: any;
}

/**
 * Generate a To url that leads back to the latest tourism query
 * @param router
 * @param history
 * @param props
 */
const preProcessesTo = (router, history, props) => {
  /**
   * Try to check if one of these paths was prior, else, use the default
   */
  return getLastPossibleNavigation(history,
    linksMap.dashboard,
    linksMap.productsByMe,
    linksMap.ordersByMeOpen,
    linksMap.adminProducts,
    {
      check: linksMap.adIdSlug,
      type: eCheckType.EQUAL,
    }
    )

    || generateSluggedAdUrl(props.product);
};


const EditorButtons = (props: IEditorButtons) => {
  return (
    <When
      condition={[PRODUCT_STATUS_WAITING_FOR_APPROVAL, PRODUCT_STATUS_PUBLISHED, PRODUCT_STATUS_DISAPPROVED].includes(props.product.status)}>
      <Switch>
        <Route exact path={linksMap.adIdSlug}>
          <LinkBlockContainer className={styles.editButtonContainer}
                              to={generateSluggedEditUrl(props.product)}>
            <MDBBtn
              block
              className={styles.editButton}
            >לערוך</MDBBtn>
          </LinkBlockContainer>
        </Route>
        <Route exact path={linksMap.adEditIdSlug}>
          {(props.nextEditorRef && props.nextEditorRef.textContent) ?
            <Button
              className={`${styles.editButton} ${styles.saveEditor}`}
              variant="contained"
              color="primary"
              onClick={() => props.nextEditorRef.click()}
            >
              {props.nextEditorRef.textContent}
            </Button>
            : <SkeletonPlaceHolder className={`${styles.editButton} ${styles.saveEditor}`}/>}
          <LinkBlockContainer className={`${styles.editButton} ${styles.cancelEditor}`}
                              preProcessesTo={(router, history) => preProcessesTo(router, history, props)}


          >
            צא מעריכה ללא שינוי
          </LinkBlockContainer>
        </Route>
      </Switch>
    </When>
  );
}

EditorButtons.defaultProps = {
  product: {},
};

export default EditorButtons;
